import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import './calendar-fix.css'
import 'react-toastify/dist/ReactToastify.css'

// Debug logs are silenced on production (app.finderz.ai) via inline script in index.html
// This ensures console.log/warn/debug/info are suppressed before any modules load
// console.error is always preserved

// Global error handlers
const setupGlobalErrorHandlers = () => {
  // Handle unhandled promise rejections
  window.addEventListener('unhandledrejection', (event) => {
    console.error('Unhandled promise rejection:', event.reason);

    // Handle token refresh errors specifically
    if (event.reason && typeof event.reason === 'string' &&
        event.reason.includes('Failed to refresh token')) {
      console.log('🔐 Handling unhandled token refresh error...');
      event.preventDefault();
      console.log('🔐 Token refresh failed, redirecting to login');
      window.location.href = '/';
      return;
    }

    // Handle authentication errors
    if (event.reason && typeof event.reason === 'string' &&
        event.reason.includes('Authentication failed')) {
      console.log('🔐 Handling unhandled authentication error...');
      event.preventDefault();
      window.location.href = '/';
      return;
    }

    // Handle Mapbox dynamic import errors
    if (event.reason && typeof event.reason === 'string' &&
        (event.reason.includes('Failed to fetch dynamically imported module') ||
         event.reason.includes('mapbox'))) {
      console.log('🗺️ Handling Mapbox dynamic import error...');
      event.preventDefault();
      console.log('🗺️ Mapbox module failed to load, this is likely a network/CDN issue');
      return;
    }

    // Handle Keycloak initialization errors
    if (event.reason && typeof event.reason === 'string' &&
        event.reason.includes('A \'Keycloak\' instance can only be initialized once')) {
      console.log('🔐 Handling Keycloak initialization error...');
      event.preventDefault();
      console.log('🔐 Keycloak already initialized, this is expected behavior');
      return;
    }
  });

  // Handle general errors
  window.addEventListener('error', (event) => {
    console.error('Global error:', event.error);

    // Handle Mapbox-specific errors
    if (event.error && event.error.message &&
        (event.error.message.includes('Cannot read properties of undefined') ||
         event.error.message.includes('mapbox') ||
         event.error.message.includes('Failed to fetch dynamically imported module'))) {
      console.warn('🗺️ Mapbox error detected, preventing crash:', event.error.message);
      event.preventDefault();
      return;
    }

    // Handle Keycloak-specific errors
    if (event.error && event.error.message &&
        event.error.message.includes('A \'Keycloak\' instance can only be initialized once')) {
      console.warn('🔐 Keycloak initialization error detected, preventing crash:', event.error.message);
      event.preventDefault();
      return;
    }
  });
};

// Setup global error handlers
setupGlobalErrorHandlers();

createRoot(document.getElementById('root')!).render(
  <>
    <App />
  </>,
)
